import React, { useState } from 'react';
import config from '../../config';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Swal from 'sweetalert2';
import { Helmet } from 'react-helmet-async';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${config.baseUrl}/forget-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Reset Password link Send Your Email Id',
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: 'Email not found',
          showConfirmButton: true, // Show the "OK" button for user acknowledgment
          timer: 3000, // Optional: Auto-close after 3
        })        
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <>
    <Helmet>
        <title>Forget Password | Corpquick</title>
        <meta name="description" content="Corpquick - Forget Password" />
      </Helmet>
      <Header />
      <section className="login-part">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="signup-form">
                <h2>
                  Forgot <span>Password</span>
                </h2>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input type="submit" value="Submit" />
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {success && <p style={{ color: 'green' }}>{success}</p>}
                  <p>
                    <Link to="/login">Sign In</Link>
                  </p>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-6"></div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ForgetPassword;
